import axios from "axios";

const resetPassword = async function (login, newPassword) {
  try {
    await axios.post('api/account/reset-password/without-mail-validation', { login, newPassword });
    return 'SUCCESS';
  } catch (e) {
    return `FAILED: ${e}`;
  }
};

export default resetPassword;
